import React from 'react';
import { FaWindowClose, FaEnvelope, FaUser, FaLandmark, FaMobile, FaRegArrowAltCircleRight, FaPenSquare} from 'react-icons/fa';

const Contact = ({setNavLinks, status, setStatus, setisFromContactJs}) => {

  
  const [inputFields, setInputFields] =React.useState({

    name: "",
    location: "",
    email: "",
    phone: "",
    message: "",

  });

  const handleInputChange = (e) => {

    const {name, value} = e.target;
    setInputFields({...inputFields, [name]: value})
  };


  const handleSubmit = async (e)=> {

    e.preventDefault();
    setStatus("Sending...");

    try{
       const response = await fetch ('https://pgtech.netlify.app/.netlify/functions/api/contact', {

          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
          },
          body: JSON.stringify(inputFields),
       });


       if (response.ok){
          setStatus("Send");
          setisFromContactJs(true);
          const result = await response.json();
          alert(result.status);

          setInputFields ({
            name: "",
            location: "",
            email: "",
            phone: "",
            message: "",
          });
          setNavLinks({successLink: true});
       } else {

          throw new Error ('Failed to send email')}
       } catch (error){

          setStatus("Send");
          console.error(error);
          alert('An error occurred while sending the mail');
       }
    };
  

   React.useEffect(()=>{

    const inputs = document.querySelectorAll("input");
    const textAreas = document.querySelectorAll("textarea");

    inputs.forEach((entrybox)=>{

      entrybox.addEventListener('blur', (event)=>{

        if(event.target.value){

          entrybox.classList.add("liftLabel");
        }else{

          entrybox.classList.remove("liftLabel");
        };
      });
    });


    textAreas.forEach((textArea)=>{  
      textArea.addEventListener('blur', (event)=>{

      if(event.target.value){

        textArea.classList.add("liftTextAreaLabel");
      }else{
        textArea.classList.remove("liftTextAreaLabel");
      };
    })});
  

  }, []);
  return (
    <div className='container-fluid'> 
        <div className='close-window-icon' ><FaWindowClose color='#1b2328' onClick={()=>{
                  setNavLinks({homeLink: true})
                  sessionStorage.setItem("currentSession", JSON.stringify({homeLink: true}));
                  }}/> </div>
        <h1 className='title'><FaEnvelope color='#1b2328' /> Contact Us </h1>

      
             <form className='form-fields' onSubmit={handleSubmit}>

                      <div className="input-field">
                          <input type="text" required name = "name" value={inputFields.name} onChange={handleInputChange} autoComplete="off"/>
                          <label htmlFor="name"><FaUser/> Name | Company</label>
                      </div>
                      <div className="input-field">
                          <input type="text" required name = "location" value={inputFields.location} onChange={handleInputChange} autoComplete="off"/>
                          <label htmlFor="location"><FaLandmark/> Address </label>
                      </div>
                      <div className="input-field">
                          <input type="email" required name = "email" value={inputFields.email} onChange={handleInputChange} autoComplete="off"/>
                          <label htmlFor="email"><FaEnvelope/> Email Address </label>
                      </div>
                      <div className="input-field">
                          <input type="number" required name = "phone" value={inputFields.phone} onChange={handleInputChange} autoComplete="off"/>
                          <label htmlFor="phone"><FaMobile/> Phone Number </label>
                      </div>
                  
                      <div  className="mess">
                        <textarea id="my-mess" name="message" value={inputFields.message} onChange={handleInputChange} required></textarea>
                        <label htmlFor="message"><FaPenSquare/> Message Us</label>
                    </div>

                    <div className="form-btns">
                      <button className='contact-form-btn'> {status} <FaRegArrowAltCircleRight/>  </button>
                    </div>

                </form>


          </div>
        

               
          
        
     

  
  )
}

export default Contact;